export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-latin-ext-500-normal.woff2?7dcca6616d928a6fd4e1ef628a85e24d";